import { useState } from 'react';

const useCustomAlert = () => {
  const [alertState, setAlertState] = useState({
    isOpen: false,
    type: 'info',
    title: '',
    message: '',
    onConfirm: null,
    onCancel: null,
    confirmText: '확인',
    cancelText: '취소'
  });

  const showAlert = ({ 
    type = 'info', 
    title = '', 
    message, 
    confirmText = '확인', 
    cancelText = '취소' 
  }) => {
    return new Promise((resolve) => {
      setAlertState({
        isOpen: true,
        type,
        title,
        message,
        confirmText,
        cancelText,
        onConfirm: () => {
          setAlertState(prev => ({ ...prev, isOpen: false }));
          resolve(true);
        },
        onCancel: () => {
          setAlertState(prev => ({ ...prev, isOpen: false }));
          resolve(false);
        }
      });
    });
  };

  const showSuccess = (message, title = '성공') => {
    return showAlert({ type: 'success', title, message });
  };

  const showError = (message, title = '오류') => {
    return showAlert({ type: 'error', title, message });
  };

  const showWarning = (message, title = '경고') => {
    return showAlert({ type: 'warning', title, message });
  };

  const showConfirm = (message, title = '확인', confirmText = '확인', cancelText = '취소') => {
    return showAlert({ type: 'confirm', title, message, confirmText, cancelText });
  };

  const showInfo = (message, title = '알림') => {
    return showAlert({ type: 'info', title, message });
  };

  return {
    alertState,
    showSuccess,
    showError,
    showWarning,
    showConfirm,
    showInfo
  };
};

export default useCustomAlert; 